<template>
  <transition
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
  >
    <div
      v-show="show"
      class="cover"
    ></div>
  </transition>
</template>

<script>
export default {
  name: 'Cover',
  data() {
    return {
      show: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = '0';
      el.style.transition = 'none';
    },
    afterEnter(el) {
      el.style.opacity = '1';
      el.style.transition = 'all 0.3s cubic-bezier(0, 0, 0.58, 1)';
    },
    beforeLeave(el) {
      el.style.opacity = '0.7';
      el.style.transition = 'all 0.1s cubic-bezier(0, 0, 0.58, 1)';
    },
  },
  watch: {
    show(val) {
      this.$emit('input', val);
    },
    value: {
      handler(val) {
        this.show = val;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.cover {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(31, 48, 67, 0.6) !important;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Cover.vue